import progressif from '@/services/api/progressif/progressif';
import JelWorkspace from '@/store/classes/jelWorkspace';

import { inMgnl, inMgnlAuthor } from '@/helpers/AppHelpers';

const jelWorkspace = new JelWorkspace({
  module: 'progressif',
  refreshMinProd: process.env.VUE_APP_STORE_PROGRESSIF_REFRESH_MIN,
  refreshMinDev: process.env.VUE_APP_STORE_DEV_REFRESH_MIN,
});

const getDefaultState = () => {
  const refreshMillisecondeLive =
    (process.env.NODE_ENV == 'production'
      ? process.env.VUE_APP_STORE_PROGRESSIF_LIVE_REFRESH_MIN
      : Math.min(
          process.env.VUE_APP_STORE_PROGRESSIF_LIVE_REFRESH_MIN,
          process.env.VUE_APP_STORE_DEV_REFRESH_MIN
        )) *
    60 *
    1000;

  return {
    ...jelWorkspace.state,
    refreshMillisecondeLive,
    progressifLive: null,
  };
};

const state = getDefaultState();

function truncMontant(mnt) {
  if (!mnt) {
    return null;
  }

  return Math.trunc(mnt);
}

const getters = {
  ...jelWorkspace.getters,
  // typeProgressif: [badBeatJackpots,bbjCasinosTerrestres,bingoJackpots,casinoJackpots,loteriesJackpots]
  getProgressif: (state) => (typeProgressif, idProgressif) => {
    if (!idProgressif || !typeProgressif) {
      return null;
    }
    if (inMgnlAuthor) {
      return 9999999;
    }

    // Comme on ne peut avoir de ":" dans un noeud jcr, on fait le replacement ici
    idProgressif = idProgressif.replace('-', ':');
    return state.progressifLive && typeof state.progressifLive === 'object'
      ? state.progressifLive[typeProgressif][idProgressif]
      : null;
  },

  // Progressif complet
  getProgressifPoker: (state, getters) => (idProgressif) => {
    return getters.getProgressif('badBeatJackpots', idProgressif);
  },
  getProgressifCasinoTerrestre: (state, getters) => (idProgressif) => {
    return getters.getProgressif('bbjCasinosTerrestres', idProgressif);
  },
  getProgressifBingo: (state, getters) => (idProgressif) => {
    return getters.getProgressif('bingoJackpots', idProgressif);
  },
  getProgressifCasino: (state, getters) => (idProgressif) => {
    return getters.getProgressif('casinoJackpots', idProgressif);
  },
  getProgressifLoterie: (state, getters) => (idProgressif) => {
    return getters.getProgressif('loteriesJackpots', idProgressif);
  },

  // Montant
  getProgressifPokerMontant: (state, getters) => (idProgressif) => {
    return truncMontant(getters.getProgressifPoker(idProgressif)?.jackpot);
  },
  getProgressifCasinoTerrestreMontant: (state, getters) => (idProgressif) => {
    return truncMontant(getters.getProgressifCasinoTerrestre(idProgressif)?.jackpot);
  },
  getProgressifBingoMontant: (state, getters) => (idProgressif) => {
    return truncMontant(getters.getProgressifBingo(idProgressif)?.jackpot);
  },
  getProgressifLoterieMontant: (state, getters) => (idProgressif, grosLot) => {
    return truncMontant(getters.getProgressifLoterie(idProgressif)?.[grosLot].value);
  },
  getProgressifCasinoMontant: (state, getters) => (progressif) => {
    if (progressif) {
      return truncMontant(getters.getProgressifCasino(progressif['@name'])?.jackpot);
    }
    return null;
  },
  isLotProgressif: (state, getters) => (progressif) => {
    return (
      progressif &&
      (progressif.image || progressif.titre || getters.getProgressifCasinoMontant(progressif))
    );
  },
};

const actions = {
  ...jelWorkspace.actions,
  refreshLive(context) {
    if (!context.rootState.idleVue.isIdle) {
      progressif
        .getProgressif()
        .then((progressif) => {
          context.commit('SET_PROGRESSIF', progressif);
        })
        .catch((error) => console.log(error));
    }

    // Délai de raffaichissement: 60 sec en PO, 30 sec en DEV.
    setTimeout(() => {
      context.dispatch('refreshLive');
    }, context.state.refreshMillisecondeLive);
  },
};

const mutations = {
  ...jelWorkspace.mutations,
  async INIT(state) {
    if (!state.isLoaded) {
      // Populer contenu store progressif.liste
      this.commit(`${state.module}/INTERNAL_INIT`);

      // Progressif inaccessible dans Magnolia
      if (!inMgnl) {
        await progressif
          .getProgressif()
          .then((progressif) => {
            this.commit(`${state.module}/SET_PROGRESSIF`, progressif);
            document.dispatchEvent(new Event('ejEventProgressifs'));
          })
          .catch((error) => console.log(error));
        if (state.refreshMillisecondeLive) {
          this.dispatch(`${state.module}/refreshLive`);
        }
      }
    }
  },
  SET_PROGRESSIF(state, progressif) {
    state.progressifLive = progressif;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
